import {
    CASCADE_ADDRESS_LEVEL1,
    CASCADE_ADDRESS_LEVEL2,
    CASCADE_ADDRESS_LEVEL3,
    CASCADE_ADDRESS_LEVEL4,
    CASCADE_ADDRESS_LEVEL5,
    CLEAR_CASCADE_ADDRESS_ACTION
} from '../../actionType';

export default function (state = {districtCity: undefined,
                                    countyMunicipality: undefined,
                                    subCountyTownCouncilDivision: undefined,
                                    parish: undefined,
                                    villageLocalCouncilZone: undefined,}, action) {
    switch (action.type) {
        case CASCADE_ADDRESS_LEVEL1:
            return {
                ...state,
                districtCity:action.districtCity,
                countyMunicipality: undefined,
                subCountyTownCouncilDivision: undefined,
                parish: undefined,
                villageLocalCouncilZone: undefined,
            };
        case CASCADE_ADDRESS_LEVEL2:
            return {
                ...state,
                countyMunicipality:action.countyMunicipality,
                subCountyTownCouncilDivision: undefined,
                parish: undefined,
                villageLocalCouncilZone: undefined,
            };
        case CASCADE_ADDRESS_LEVEL3:
            return {
                ...state,
                subCountyTownCouncilDivision:action.subCountyTownCouncilDivision,
                parish: undefined,
                villageLocalCouncilZone: undefined,
            };
        case CASCADE_ADDRESS_LEVEL4:
            return {
                ...state,
                parish:action.parish,
                villageLocalCouncilZone: undefined,
            };
        case CASCADE_ADDRESS_LEVEL5:
            return {
                ...state,
                villageLocalCouncilZone:action.villageLocalCouncilZone,
            };
        case CLEAR_CASCADE_ADDRESS_ACTION:
            return {districtCity: undefined,
                countyMunicipality: undefined,
                subCountyTownCouncilDivision: undefined,
                parish: undefined,
                villageLocalCouncilZone: undefined,};
        default:
            return state;
    }
}
